import type {NativeMessageResult} from './types';

// Delivery results from the pinned native prompt, steer and continuation methods.
const acceptedStatuses = new Set(['streaming', 'steered', 'redirected', 'queued', 'dispatched', 'completed']);

export function nativeMessageAccepted(result: NativeMessageResult): boolean {
  if (result.status === 'rejected') return false;
  if (acceptedStatuses.has(result.status)) return true;
  throw new Error(`Hermes returned an unrecognized message delivery result: ${JSON.stringify(result)}`);
}
